import { useDispatch, useSelector } from "react-redux";
import { homeDataAction } from "../state/homeState";

/**
 * Custom hook for managing playground modal state
 * This hook provides a clean interface for managing the showPlaygroundLinkInModal state
 * following the single responsibility principle
 */
export const usePlaygroundModal = () => {
  const dispatch = useDispatch();
  const showPlaygroundLinkInModal = useSelector(
    (state: any) => state.homeState.showPlaygroundLinkInModal
  );

  const showPlaygroundModal = () => {
    dispatch(homeDataAction.setShowPlaygroundLinkInModal(true));
  };

  const hidePlaygroundModal = () => {
    dispatch(homeDataAction.setShowPlaygroundLinkInModal(false));
  };

  const togglePlaygroundModal = () => {
    dispatch(homeDataAction.togglePlaygroundLinkInModal());
  };

  return {
    showPlaygroundLinkInModal,
    showPlaygroundModal,
    hidePlaygroundModal,
    togglePlaygroundModal,
  };
};
